import React from "react";
import ReactDom from "react-dom";
import { store } from "./Redux/Store";
import { Provider } from "react-redux";
import "./index.css";
// import { BrowserRouter } from "react-router-dom";
import "./i18n";

import App from "./App";
const root = ReactDom.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App store={store} />
  </Provider>
);
// ReactDom.render(<App />, document.getElementById("root"));
